<div class="container">
  <rd-shared-breadcrumb
    [breadcrumbText]="'transfer_v2.checkout.back_to_programs' | translate"
    [redirectURL]="'/transfer/programs'"
    [displayModeDesktop]="'stacked'"
    [displayModeMobile]="'stacked'">
  </rd-shared-breadcrumb>

  <div class="desktop-container">
    <div class="desktop-left rounded-md">
      <rd-tcv2-checkout-terms-list-wrapper
        class="mx-4 mt-3 mb-6 lg:mt-0 lg:mr-0"
        [loading]="loyaltyProgramLoading$ | async"
        [loyaltyProgram]="loyaltyProgram$ | async">
      </rd-tcv2-checkout-terms-list-wrapper>
    </div>

    <div class="desktop-right lg:ml-10">
      <rd-tcv2-checkout-program-description
        class="mx-4 mb-3 lg:ml-0 lg:mb-4"
        [loading]="loyaltyProgramLoading$ | async"
        [loyaltyProgram]="loyaltyProgram$ | async"
        [additionalInformation]="anzPromo">
      </rd-tcv2-checkout-program-description>
      <ng-container *ngIf="loyaltyProgram$ | async as loyaltyProgram">
        <p
          class="enrollment-text"
          *ngIf="shouldRenderEnrollmentText"
          [ngClass]="{ 'ml-4': shouldRenderLinkedAccountOnTop }">
          <span class="enrollment-question">{{
            'transfer_v2.checkout.not_a_member' | translate
          }}</span>
          <rd-shared-link
            class="enrollment-url"
            [text]="'transfer_v2.checkout.join_now' | translate"
            [path]="
              loyaltyProgram.pointsTransferCapability.enrollmentUrl.toString()
            "
            [isTargetBlank]="true">
          </rd-shared-link>
        </p>
      </ng-container>

      <anz-campaign-banner-tc-details> </anz-campaign-banner-tc-details>
      <ng-template #anzPromo>
        <rd-shared-alert
          *ngIf="promotionTranslationKey"
          class="mt-4 mb-1 lg:mb-2"
          alertTheme="transparent"
          icon="promo">
          <span
            [innerHTML]="
              promotionTranslationKey
                | translate
                  : {
                      findOutMoreUrl:
                        loyaltyProgram.pointsTransferCapability.detailsUrl?.toString()
                    }
            "></span>
        </rd-shared-alert>
      </ng-template>

      <rd-tcv2-checkout-form
        class="mb-4 lg:mb-8"
        [formData]="checkoutFormData$ | async"
        [disabled]="shouldDisableForm"
        [isLoggedIn]="isLoggedIn"
        [loyaltyProgram]="loyaltyProgram$ | async"
        (submitForm)="submitCheckoutFormData($event)"
        [linkedAccount]="loyaltyProgramMembership$ | async"
        [loyaltyProgramOrMembershipsLoading]="
          loyaltyProgramOrMembershipsLoading$ | async
        "></rd-tcv2-checkout-form>
      <div
        *ngIf="shouldRenderAdditionalMessage"
        class="checkout-additional-information mx-4 mb-9 lg:mb-10 lg:ml-0">
        <h4
          class="checkout-additional-title mt-0 mb-4"
          [innerHtml]="
            transferConnectV2SettingService.checkoutPageText
              .additionalCheckoutTitle.translationKey | translate
          "></h4>
        <div
          class="checkout-additional-message"
          [innerHtml]="
            transferConnectV2SettingService.checkoutPageText
              .additionalCheckoutMessage.translationKey | translate
          "></div>
      </div>
    </div>
  </div>
</div>
